import OrderDetailInformation from "./../Order/OrderDetailInformation";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./../CustomedFields/FormikControl";
import OrderMakingPrint from "./../Order/OrderMakingPrint";
import ReactToPrint from "react-to-print";

const ShowSingleMeasurement = (props) => {
  const printableRef_MeasurementAllItem = useRef(null);
  const [arrayOrderDetail, setArrayOrderDetail] = useState([]);

  // alert("props.mode : " + props.mode);
  // alert("props.indexEntry : " + props.indexEntry);
  // debugger;

  const handleClickModeChange = (indexNo, mode) => {
    // alert(
    //   "The link was clicked.(Show single measurement)" + indexNo + ", " + mode
    // );
    props.changeMode(indexNo, mode);
  };

  const handleClickDelete = (indexNo, orderDetailID_GUID_props) => {
    // alert(
    //   "Show component: The link was clicked." +
    //     indexNo +
    //     ", " +
    //     orderDetailID_GUID_props
    // );
    props.removeOrderItem(indexNo, orderDetailID_GUID_props);
  };

  useEffect(() => {
    // setArrayOrderDetail([...arrayOrderDetail, ...props.orderDetailProps]);
    setArrayOrderDetail([]);
    setArrayOrderDetail((prevArray) => [...prevArray, props.orderDetailProps]);
  }, [props.orderDetailProps]);

  return (
    <Fragment>
      Mode: {props.entryEditOrViewMode}
      <hr />
      <div
        className="media mb-4 mt-1 divWithBgColor"
        style={{ padding: "10px" }}
      >
        <div className="media-body">
          <div className="ordermeasure-title">
            <span className="float-right">
              {/* {props.lstMeasurementDetail.length} */}{" "}
              <div className="btn-group m-b-20">
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-primary px-3">
                      Print {props.lstMeasurementDetail[0].name} Measurement
                    </button>
                  )}
                  content={() => printableRef_MeasurementAllItem.current}
                />
                {props.mode === 3 && (
                  <button
                    onClick={() => {
                      handleClickModeChange(props.indexEntry, 2);
                    }}
                    type="button"
                    className="btn btn-light"
                  >
                    <i className="fa fa-edit"></i>
                  </button>
                )}
                {(props.mode === 1 || props.mode === 2) && (
                  <button
                    onClick={() => {
                      handleClickModeChange(props.indexEntry, 3);
                    }}
                    type="button"
                    className="btn btn-light"
                  >
                    <i className="fa fa-save"></i>
                  </button>
                )}
                <button
                  onClick={() => {
                    handleClickDelete(
                      props.indexEntry,
                      props.orderDetailID_GUID_props
                    );
                  }}
                  type="button"
                  className="btn btn-light"
                >
                  <i className="fa fa-trash"></i>
                </button>
                {/* Copy of measurement */}
                <button
                  onClick={() => {
                    props.Copy_OrderItem(
                      props.indexEntry,
                      props.orderDetailID_GUID_props,
                      props.lstMeasurementDetail[0]?.productItemID_GUID
                    );
                  }}
                  type="button"
                  className="btn btn-light"
                >
                  Copy Measurement
                </button>
              </div>
            </span>
            <h4 className="m-0 text-primary">
              {props.lstMeasurementDetail[0].name}
              {/* {props.lstMeasurementDetail[0].productItemID_GUID} */}(
              {
                // props.mode
                (() => {
                  switch (true) {
                    case props.mode === 1:
                      {
                        return <>ADD</>;
                      }
                      break;

                    case props.mode === 2:
                      {
                        return <>EDIT</>;
                      }
                      break;

                    default:
                      {
                        return <>VIEW</>;
                      }
                      break;
                  }
                })()
              }
              )
            </h4>
          </div>
          <div className="clearBoth"></div>
          <div className="row margin_zero bg_color_skyBlue">
            <div className="col-xl-12 margin_padding_zero">
              <div className="card padding-Zero-Important margin-Zero-Important bg_color_lightGreen">
                eeeeeeeeeeeerrrrrrrrrrrrrrrrrrrrrrrrrrrr
                <div className="card-body padding-Zero-Important margin-Zero-Important bg_color_lightGreen">
                  <div className="basic-list-group bg_color_lightGreen">
                    {/* <div style={{ float: "right", marginRight: "10px" }}>
                      <ReactToPrint
                        trigger={() => (
                          <button className="btn btn-primary px-3">
                            Print Order Measurement
                          </button>
                        )}
                        content={() => printableRef_MeasurementAllItem.current}
                      />
                    </div> */}

                    {/* print display - none */}
                    <div className="print_99" style={{ display: "none" }}>
                      <div ref={printableRef_MeasurementAllItem}>
                        <OrderMakingPrint
                          customerStore={props.customerStoreProps}
                          orderStore={props.orderStoreProps}
                          orderItemDetailStoreProp={arrayOrderDetail}
                          orderDetailID_GUID_props={
                            props.orderDetailID_GUID_props
                          }
                          // orderItemDetailStoreProp={orderItemDetailStore}
                        />
                      </div>
                    </div>

                    {/* Comment : Note */}
                    <div
                      className="form-control-customed single_input"
                      style={{
                        width: "620px",
                        float: "left",
                      }}
                    >
                      <div style={{ height: "23px" }}>
                        {"Comments"}
                        {/* ddd{JSON.stringify(item)} */}
                      </div>
                      <div style={{ clear: "both" }}></div>
                      <div
                        style={{
                          width: "620px",
                          float: "left",
                        }}
                      >
                        <input
                          name={"Note"}
                          className="single_input_text"
                          id={"Note"}
                          type="text"
                          value={props.orderProductItem[0]?.note}
                          style={{ width: "600px" }}
                        />
                      </div>
                    </div>
                    {/* QTY : */}
                    <div
                      className="form-control-customed single_input"
                      style={{
                        width: "110px",
                        float: "right",
                        marginRight: "12px",
                      }}
                    >
                      <div style={{ height: "23px" }}>{"Qty"}</div>
                      <div style={{ clear: "both" }}></div>
                      <div
                        style={{
                          width: "110px",
                          marginRight: "0px",
                        }}
                      >
                        <input
                          name={"Qty"}
                          className="single_input_text"
                          id={"Qty"}
                          type="text"
                          value={props.orderProductItem[0]?.qty}
                          style={{ width: "40px" }}
                        />
                      </div>
                    </div>
                    {/* Price : */}
                    <div
                      className="form-control-customed single_input"
                      style={{
                        width: "150px",
                        float: "right",
                        marginRight: "40px",
                      }}
                    >
                      <div style={{ height: "23px" }}>{"Price"}</div>
                      <div style={{ clear: "both" }}></div>
                      <div
                        style={{
                          width: "150px",
                          marginRight: "40px",
                        }}
                      >
                        <input
                          name={"Price"}
                          className="single_input_text"
                          id={"Price"}
                          type="text"
                          value={props.orderProductItem[0]?.unitPrice}
                          style={{ width: "40px" }}
                        />
                      </div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    {props.lstMeasurementDetail
                      .filter((measurementDetail) => {
                        return measurementDetail.isNote === false;
                      })
                      .map((item, index) => {
                        return (
                          <>
                            <div className="form-control-customed single_input">
                              <div style={{ height: "23px" }}>
                                {item.fieldName}
                                {/* ddd{JSON.stringify(item)} */}
                              </div>
                              <div style={{ clear: "both" }}></div>
                              <div>
                                <input
                                  name={item.measurementSettingsDetailsID_GUID}
                                  className="single_input_text"
                                  id={item.measurementSettingsDetailsID_GUID}
                                  type="text"
                                  value={item.value}
                                />
                              </div>
                            </div>

                            {/* <div style={{ width: "30%", float: "left" }}>
                            {item.fieldName}
                          </div>
                          <div style={{ width: "30%", float: "left" }}>
                            {item.value}
                          </div> */}
                          </>
                        );
                      })}
                    <div style={{ clear: "both" }}></div>
                    <div
                      style={{
                        marginTop: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      Extended Note (Show):
                    </div>
                    <hr />
                    <div style={{ clear: "both" }}></div>
                    {props.lstMeasurementDetail
                      .filter((measurementDetail) => {
                        return measurementDetail.isNote === true;
                      })
                      .map((item, index) => {
                        if (item.fieldType === 1) {
                          // text box
                          if (
                            item.value !== null &&
                            item.value !== "" &&
                            item.value !== "undefined"
                          ) {
                            return (
                              <>
                                <div className="form-control-customed single_input">
                                  <div style={{ height: "23px" }}>
                                    {item.fieldName}
                                    {/* ddd{JSON.stringify(item)} */}
                                  </div>
                                  <div style={{ clear: "both" }}></div>
                                  <div>
                                    <input
                                      name={
                                        item.measurementSettingsDetailsID_GUID
                                      }
                                      className="single_input_text"
                                      id={
                                        item.measurementSettingsDetailsID_GUID
                                      }
                                      type="text"
                                      value={item.value}
                                    />
                                  </div>
                                </div>
                              </>
                            );
                          }
                        } else if (item.fieldType === 2) {
                          // Check box
                          if (
                            item.value !== null &&
                            item.value !== "" &&
                            item.value !== "undefined" &&
                            item.value === "True"
                          ) {
                            return (
                              <>
                                <div className="form-control-customed single_input">
                                  <div style={{ minHeight: "10px" }}>
                                    {item.fieldName}
                                  </div>
                                  <div style={{ clear: "both" }}></div>
                                </div>
                              </>
                            );
                          }
                        }
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ShowSingleMeasurement;
